import React, { useState } from "react";
import { Link } from "react-router-dom";
import PageLayout from "../../components/PageLayout";
import FAQ from "../../components/FAQ";
import SEO from "../../components/SEO";
import { ContactModal } from "../../components/calltoactions/ContactModal";
import { contact } from "../../config/site";

const faqItems = [
  {
    q: "כמה עולה ייעוץ משפטי ראשוני?",
    a: "ייעוץ ראשוני במשרדנו מתבצע בתשלום סמלי. בפגישה נשמע את פרטי המקרה, נעריך את הסיכויים ונציג את דרכי הפעולה האפשריות — ללא כל התחייבות.",
  },
  {
    q: "מתי כדאי לפנות לעורך דין?",
    a: "מומלץ לפנות לעורך דין בהקדם האפשרי — עוד לפני שחותמים על מסמכים, מקבלים החלטות בעלות השלכות משפטיות, או מעורבים בסכסוך. פנייה מוקדמת מגדילה משמעותית את סיכויי ההצלחה.",
  },
  {
    q: "האם המשרד מטפל גם בתיקים פליליים?",
    a: "המשרד מתמחה בעיקר בתחומי המשפט האזרחי והמסחרי, לרבות ליטיגציה, נדל\"ן, דיני משפחה, תעבורה ועוד. לקביעת פגישה לבדיקת התיק שלכם — צרו קשר.",
  },
  {
    q: "כמה זמן לוקח לסגור תיק משפטי?",
    a: "משך הטיפול המשפטי תלוי בסוג התיק וברמת המורכבות שלו. הליכים מחוץ לכותלי בית המשפט עשויים להסתיים תוך שבועות, בעוד הליכים משפטיים מלאים יכולים לקחת חודשים עד שנים. אנו שואפים לפתרון יעיל ומהיר ככל האפשר.",
  },
  {
    q: "האם ניתן לקבל ייעוץ טלפוני?",
    a: "כן. ניתן ליצור קשר טלפוני לבירורים ראשוניים. עם זאת, לצורך בחינה מעמיקה של המקרה מומלץ לקבוע פגישה פנים אל פנים.",
  },
];

const LawyerBeerSheva = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
  <>
  <PageLayout>
    <SEO
      title="עורך דין בבאר שבע | משרד וידבסקי ושות׳"
      description="מחפשים עורך דין בבאר שבע? משרד עו״ד וידבסקי ושות׳ מציע ייצוג וייעוץ משפטי מקצועי בתחומי נדל״ן, תעבורה, דיני משפחה, נזיקין ועוד. התקשרו עכשיו."
      path="/orech-din-beer-sheva"
      faqItems={faqItems}
      breadcrumbs={[
        { name: "דף הבית", url: "/" },
        { name: "עורך דין בבאר שבע", url: "/orech-din-beer-sheva" },
      ]}
    />

    {/* Hero */}
    <section className="content_page_hero">
      <div className="container">
        <ul className="breadcrumb">
          <li><Link to="/">דף הבית</Link></li>
          <li>עורך דין בבאר שבע</li>
        </ul>
        <h1>עורך דין בבאר שבע</h1>
        <p className="hero_subtitle">
          משרד עו״ד וידבסקי ושות׳ מספק שירותים משפטיים מקצועיים בבאר שבע והסביבה —
          ייצוג, ליווי וייעוץ בכל תחומי המשפט האזרחי והמסחרי.
        </p>
      </div>
    </section>

    {/* Intro */}
    <section className="page_section">
      <div className="container page_content">
        <div className="page_intro_grid">
          <div>
            <div className="shane_tm_title">
              <span>אודות המשרד</span>
              <h2>למה לבחור במשרד וידבסקי ושות׳?</h2>
            </div>
            <p>
              משרד עו״ד וידבסקי ושות׳ הוא משרד עורכי דין ותיק ומוביל בבאר שבע, המתמחה
              במגוון רחב של תחומי המשפט. אנו מאמינים כי כל לקוח ראוי לייצוג מיטבי —
              ומקפידים על זמינות, שקיפות ויחס אישי לאורך כל ההליך.
            </p>
            <p>
              עו״ד כפיר וידבסקי, ראש המשרד, צבר ניסיון עשיר בייצוג לקוחות פרטיים,
              עסקים וחברות בפני בתי משפט השלום, המחוזי ובוררויות. ההיכרות המעמיקה
              עם מערכת המשפט המקומית בבאר שבע מאפשרת למשרד להעניק ייצוג יעיל ומדויק.
            </p>
          </div>
          <div>
            <ul>
              <li>ניסיון עשיר בייצוג בפני בתי המשפט בבאר שבע</li>
              <li>מענה מהיר, זמינות גבוהה ויחס אישי</li>
              <li>שקיפות מלאה בנושא שכר הטרחה</li>
              <li>ליווי מקצועי בכל שלבי ההליך המשפטי</li>
              <li>ייעוץ ראשוני לבדיקת המקרה</li>
              <li>שפות: עברית, רוסית, אנגלית</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    {/* Services */}
    <section className="page_section bg_light">
      <div className="container page_content">
        <div className="shane_tm_title">
          <span>תחומי ההתמחות</span>
          <h2>שירותים משפטיים בבאר שבע</h2>
        </div>
        <p>
          המשרד מציע מגוון רחב של שירותים משפטיים לפרטיים, עסקים ותאגידים באזור
          באר שבע, הנגב ומרחבי הדרום:
        </p>
        <div className="page_cards">
          {[
            { icon: "⚖️", title: "ליטיגציה ויישוב סכסוכים", desc: "ייצוג בבתי משפט, בוררויות וגישור — מהגשת התביעה ועד לפסיקה." },
            { icon: "🏠", title: "נדל\"ן ומיסוי מקרקעין", desc: "עסקאות רכישה ומכירה, חוזים, ליווי פרויקטים ומיסוי מקרקעין." },
            { icon: "🚗", title: "דיני תעבורה", desc: "ייצוג בעבירות תנועה, שלילת רישיון, תאונות דרכים וקנסות." },
            { icon: "👨‍👩‍👧", title: "דיני משפחה", desc: "גירושין, הסכמי ממון, ירושות, צוואות וייפוי כוח מתמשך." },
            { icon: "💼", title: "משפט מסחרי ותאגידי", desc: "הקמת חברות, חוזים מסחריים, ליווי שוטף לעסקים וסטארט-אפים." },
            { icon: "🏛️", title: "הוצאה לפועל וחדלות פירעון", desc: "גביית חובות, הסדרי נושים, הליכי פשיטת רגל ומימוש נכסים." },
          ].map((s) => (
            <div className="card" key={s.title}>
              <div className="card_icon">{s.icon}</div>
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* How we work */}
    <section className="page_section">
      <div className="container page_content">
        <div className="shane_tm_title">
          <span>תהליך העבודה</span>
          <h2>איך אנחנו עובדים?</h2>
        </div>
        <div className="page_steps">
          {[
            { n: "1", title: "פגישת ייעוץ ראשונית", desc: "בפגישה נשמע את המקרה, נבין את צרכיכם ונעריך את האפשרויות העומדות בפניכם — ללא התחייבות." },
            { n: "2", title: "בחינה וגיבוש אסטרטגיה", desc: "לאחר בחינת כלל המסמכים והעובדות, נגבש אסטרטגיה משפטית מותאמת אישית למטרותיכם." },
            { n: "3", title: "ייצוג וליווי מלא", desc: "נלווה אתכם בכל שלבי ההליך — מול הצד השני, מול בית המשפט, ועד לסיום מוצלח." },
          ].map((s) => (
            <div className="step" key={s.n}>
              <div className="step_number">{s.n}</div>
              <div className="step_content">
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* Location */}
    <section className="page_section bg_light">
      <div className="container page_content">
        <div className="shane_tm_title">
          <span>מיקום המשרד</span>
          <h2>עורך דין זמין בבאר שבע</h2>
        </div>
        <div className="page_intro_grid">
          <div>
            <p>
              המשרד ממוקם ברחוב הרצל 118, באר שבע — בלב העיר, בסמוך לבתי המשפט
              המחוזי והשלום של המחוז הדרומי. הנגישות הגאוגרפית מקצרת דרכים
              וחוסכת זמן יקר עבור לקוחותינו.
            </p>
            <p>
              אנו מייצגים לקוחות מבאר שבע, דימונה, אשקלון, אשדוד, קרית גת,
              נתיבות, אופקים וכלל אזור הדרום. במקרים מתאימים ניתן לקיים ייעוץ
              בוידאו קול.
            </p>
            <div className="highlight_box">
              <p>
                📍 <strong>כתובת:</strong> {contact.address}<br />
                📞 <strong>טלפון:</strong> {contact.phones[0].label} | {contact.phones[1].label}
              </p>
            </div>
          </div>
          <div>
            <iframe
              title="מפת המשרד"
              src={contact.mapEmbedUrl}
              width="100%"
              height="300"
              style={{ border: 0, borderRadius: "6px" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>

    {/* FAQ */}
    <section className="page_section">
      <div className="container page_content">
        <div className="shane_tm_title">
          <span>שאלות נפוצות</span>
          <h2>כל מה שרציתם לדעת</h2>
        </div>
        <FAQ items={faqItems} />
      </div>
    </section>

    {/* CTA */}
    <section className="page_cta_banner">
      <div className="container">
        <h2>צריכים עורך דין בבאר שבע?</h2>
        <p>פנו אלינו עוד היום לייעוץ ראשוני. אנחנו כאן בשבילכם.</p>
        <div className="cta_buttons">
          <a href={contact.phones[0].href} className="cta_primary">
            התקשרו עכשיו — {contact.phones[0].label}
          </a>
          <button className="cta_secondary" onClick={() => setIsOpen(true)}>
            שלחו הודעה
          </button>
        </div>
      </div>
    </section>
  </PageLayout>
  <ContactModal isOpen={isOpen} setIsOpen={setIsOpen} />
  </>
  );
};

export default LawyerBeerSheva;
